import React, { Component } from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';

class ServiceParams extends Component {
    render() {
        var wsdlDoc=this.props.wsdlDoc;
        return (
            <div key={wsdlDoc.title}>
                <h3>{renderHTML(wsdlDoc.title)}</h3>
                <ul>
                    {wsdlDoc.params.map(para => {
                        return (
                            <li key={para.title}><b>{para.title} </b>
                                ({renderHTML(para.type)})
                                <p>
                                {para.content}</p> </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
}

ServiceParams.propTypes={
    wsdlDoc:PropTypes.object
}

export default ServiceParams;